import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

// formik components
import { Formik, Form } from "formik";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// NewUser layout schemas for form and form feilds
import validations from "./schemas/Validations";
import form from "./schemas/Form";
import initialValues from "./schemas/InitialValues";
import PAInfo from "./components/PAInfo";

import { URL_API } from "config";

function getSteps() {
  return ["Dados"];
}

function getStepContent(stepIndex, formData) {
  switch (stepIndex) {
    case 0:
      return <PAInfo formData={formData} />;
    default:
      return null;
  }
}

export default function CreatePA() {
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const { formId, formField } = form;
  const currentValidation = validations[activeStep];
  const isLastStep = activeStep === steps.length - 1;
  const navigate = useNavigate();
  let tag = localStorage.getItem("Tag");

  const handleBack = () => setActiveStep(activeStep - 1);

  const submitForm = async (values, actions) => {
    await axios
      .post(URL_API + "/pa", values, {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      })
      .then(() => {
        navigate("/admin/pas");
        toast.success("Dados criados com sucesso");
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      })
      .finally(() => {
        actions.setSubmitting(false);
        actions.resetForm();

        setActiveStep(0);
      });
  };

  const handleSubmit = (values, actions) => {
    if (isLastStep) {
      submitForm(values, actions);
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox mb={5}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ height: "100%", mt: 8 }}
          >
            <Grid item xs={12} lg={8}>
              <Formik
                initialValues={initialValues}
                validationSchema={currentValidation}
                onSubmit={handleSubmit}
              >
                {({ values, errors, touched, isSubmitting }) => (
                  <Form id={formId} autoComplete="off">
                    <Card sx={{ height: "100%" }}>
                      <MDBox p={3}>
                        <MDBox>
                          {getStepContent(activeStep, {
                            values,
                            touched,
                            formField,
                            errors,
                          })}
                          <MDBox
                            mt={2}
                            width="100%"
                            display="flex"
                            justifyContent="space-between"
                          >
                            {activeStep === 0 ? (
                              <MDBox />
                            ) : (
                              <MDButton
                                variant="gradient"
                                color="light"
                                onClick={handleBack}
                              >
                                voltar
                              </MDButton>
                            )}
                            <MDButton
                              disabled={isSubmitting}
                              type="submit"
                              variant="gradient"
                              color="dark"
                            >
                              {isLastStep ? "salvar" : "próximo"}
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </Form>
                )}
              </Formik>
            </Grid>
          </Grid>
        </MDBox>
      </DashboardLayout>
      <ToastContainer />
    </>
  );
}
